import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectAppSettings } from "../../redux/slices/appSettingsSlice";
import RegistrationContentControl from "./RegistrationContentControl";

const ConnectedRegistrationContentControl = ({ controlId }) => {
    const appSettings = useSelector(selectAppSettings);
    const { showRegistrationRole, showRemainingForm } = appSettings;
    const registrationContentControlProps = {
        controlId,
        showRegistrationRole,
        showRemainingForm,
    };
    return <RegistrationContentControl {...registrationContentControlProps} />;
};

ConnectedRegistrationContentControl.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedRegistrationContentControl;
